import { AfterViewInit, Component, Input } from '@angular/core';
import { BaseResourceItemsComponent, Contrato, ContratoTerceirizado, ContratoTerceirizadoStorage, DateFormatPipe, EddyAutoComplete, ExercicioService, FuncaoService, GlobalService, Login, Setor, SetorService } from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import { takeUntil } from 'rxjs/operators';
import { ContratoTerceirizadoStorageService } from '../service/contrato-terceirizado-storage.service';
import { ContratoTerceirizadoService } from '../service/contrato-terceirizado.service';
import { error, info, success, warning } from 'toastr';

declare var $: any;

@Component({
  selector: 'lib-contrato-terceirizado',
  templateUrl: './contrato-terceirizado.component.html',
  styleUrls: ['./contrato-terceirizado.component.css'],
})
export class ContratoTerceirizadoComponent
  extends BaseResourceItemsComponent<ContratoTerceirizado>
  implements AfterViewInit {

  @Input() contrato: Contrato;
  @Input() login: Login;
  @Input() visualizar: Boolean;

  public setorAutoComplete: EddyAutoComplete<Setor>;
  public ptBR: any;

  public arquivos: ContratoTerceirizadoStorage[] = [];
  public uploadedFiles: any[] = [];
  public descricao: string = null;

  private itemSelecionado: ContratoTerceirizado = null;

  constructor(
    protected contratoTerceirizadoService: ContratoTerceirizadoService,
    protected confirmationService: ConfirmationService,
    protected exercicioService: ExercicioService,
    public globalService: GlobalService,
    public setorService: SetorService,
    public funcaoService: FuncaoService,
    private contratoTerceirizadoStorageService: ContratoTerceirizadoStorageService
  ) {
    super(new ContratoTerceirizado(), contratoTerceirizadoService);
    this.persistence = true;
    this.ptBR = this.globalService.obterDataBR();
  }

  // ─── Lifecycle ───────────────────────────────────────────────────────────────

  protected afterInit(): void {
    this.carregarAutoCompletes();
  }

  ngAfterViewInit(): void {
    this.resetarUpload();

    $('#UploadArquivoTerceirizado').on('hidden.bs.modal', () => {
      if ($('#TabelaArquivoTerceirizado').hasClass('show')) {
        $('body').addClass('modal-open');
        $('.modal-backdrop').last().remove();
      }
    });
  }

  // ─── AutoComplete ─────────────────────────────────────────────────────────────

  private carregarAutoCompletes(): void {
    this.setorAutoComplete = new EddyAutoComplete(null, this.setorService,
      'id', ['codigo', 'nome'], { orgao_id: this.login.orgao.id, orderBy: 'nome' }, { text: ['nome', 'codigo'] }
    );
  }

  protected validSave(item: ContratoTerceirizado): boolean {
    if (!item.nome?.trim()) {
      warning('Informe o nome!');
      return false;
    }
    if (!item.cpf?.trim()) {
      warning('Informe o CPF!');
      return false;
    }
    if (!item.setor) {
      warning('Informe o local de trabalho!');
      return false;
    }
    if (!item.cargo?.trim()) {
      warning('Informe o cargo/função!');
      return false;
    }
    if (!item.data_admissao) {
      warning('Informe a data de admissão!');
      return false;
    }

    item.contrato = { id: this.contrato.id };
    return true;
  }

  protected beforeSave(_item: ContratoTerceirizado): void {
    this.anterior = null;
  }

  protected afterEdit(item: ContratoTerceirizado): void {
    if (!item?.id) {
      item.ativo = true
    }

    item.data_admissao = new DateFormatPipe().transform(item.data_admissao, []);
    item.data_demissao = new DateFormatPipe().transform(item.data_demissao, []);
  }

  public atribuirItemAoStorage(item: ContratoTerceirizado): void {
    this.itemSelecionado = item;
    this.contratoTerceirizadoStorageService
      .filtrar(1, -1, { 'terceirizado.id': item.id })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => (this.arquivos = res.content));
  }

  public abrirModalUpload(): void {
    ($('#UploadArquivoTerceirizado') as any).modal('show');

    setTimeout(() => {
      const backdrops = $('.modal-backdrop');
      $(backdrops[0]).css('z-index', 1040);
      $(backdrops[1]).css('z-index', 1060);
      $('#UploadArquivoTerceirizado').css('z-index', 1070);
    }, 0);
  }

  /**
   * Chamado pelo p-fileUpload (customUpload + auto).
   * Apenas coleta os arquivos na lista — o envio efetivo ocorre em confirmarUpload().
   */
  public onUpload(event: any, fileUpload: any): void {
    if (!event.files?.length) {
      warning('Selecione o(s) arquivo(s)');
      return;
    }

    for (const file of event.files) {
      this.uploadedFiles.push(file);
    }

    fileUpload.clear();
  }

  public ItemEditavel(): boolean {
    return this.lista?.some((item: any) => item.editavel) ?? false;
  }

  public removerArquivoLista(file: any): void {
    this.uploadedFiles.splice(this.uploadedFiles.indexOf(file), 1);
  }

  public async confirmarUpload(): Promise<void> {
    if (!this.uploadedFiles.length) {
      warning('Nenhum arquivo selecionado.');
      return;
    }

    const chunks = this.dividirLista(this.uploadedFiles, 5);

    try {
      for (const chunk of chunks) {
        const res: any[] = await this.contratoTerceirizadoStorageService
          .upload(chunk, this.login.orgao.id, this.itemSelecionado.id, this.descricao)
          .toPromise();

        for (const arquivo of res) {
          arquivo.data_cadastro = new Date();
          this.arquivos.unshift(arquivo);
        }
      }

      success('Arquivo(s) adicionado(s) com sucesso!');
    } catch {
      error('Erro ao salvar arquivo(s).');
    } finally {
      this.resetarUpload();
      $('#UploadArquivoTerceirizado').modal('hide');
    }
  }

  public async toggleTransparencia(item: ContratoTerceirizadoStorage): Promise<void> {
    if (!item) return;

    item.visivel_transparencia = !item.visivel_transparencia;

    this.contratoTerceirizadoStorageService
      .atualizar(item)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        () => success('Visibilidade atualizada com sucesso!'),
        (err) => {
          item.visivel_transparencia = !item.visivel_transparencia; // reverte em caso de erro
          error(err?.error?.payload ?? 'Erro ao atualizar visibilidade.');
        }
      );
  }

  public remover(item: ContratoTerceirizadoStorage): void {
    if (!item) return;

    this.confirmationService.confirm({
      key: 'tipoDocumento',
      header: 'Exclusão',
      message: 'Deseja realmente remover o arquivo?',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirmar',
      rejectLabel: 'Cancelar',
      accept: () => {
        this.contratoTerceirizadoStorageService
          .remover(item.id)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            () => {
              this.arquivos.splice(this.arquivos.indexOf(item), 1);
              info('Arquivo removido com sucesso!', 'Exclusão');
            },
            (err) => error(err?.error?.payload ?? 'Erro ao remover arquivo.')
          );
      },
    });
  }

  private dividirLista<T>(arr: T[], tamanho: number): T[][] {
    const result: T[][] = [];
    for (let i = 0; i < arr.length; i += tamanho) {
      result.push(arr.slice(i, i + tamanho));
    }
    return result;
  }

  private resetarUpload(): void {
    this.uploadedFiles = [];
    this.descricao = null;
  }
}